<template>
    <Panel header="Inscrição" :toggleable="false">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(cadastrar)" method="post" enctype="multipart/form-data">

            <div class="p-fluid formgrid grid">

            <transition-group name="p-messages" tag="div" class="col-12 md:col-12">
                <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
            </transition-group>

            <div class="field col-12 md:col-12">
				<label for="nome" class="font-bold mr-4">Processo Seletivo</label>
				<label>{{processo.nome}}</label>
			</div>

            <div class="field col-12 md:col-3">
                <label for="Área" class="font-bold required">Área</label>
                    <ValidationProvider name="área" rules="required" v-slot="{ errors }" mode="lazy">
                        <Dropdown id="area" v-model="inscricao.areaId" :options="dropdownAreas" :filter="true"
                            optionLabel="area.nome" placeholder="Selecione uma área ..." optionValue="id"
                            :class="{ 'field-invalid': errors[0]  }" />
                        <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                    </ValidationProvider>
            </div>

            <div class="field col-12 md:col-3" v-if="processo.tipoSelecao.estagio">
                <label for="coeficiente" class="font-bold required">Coeficiente de rendimento</label>
                <ValidationProvider name="Coeficiente de rendimento" :rules="rules" v-slot="{ errors}" mode="lazy">
                    <InputNumber id="coeficiente" v-model="inscricao.coefic_red_escolar"
                            mode="decimal" locale="pt-BR"
                            :minFractionDigits="2" :maxFractionDigits="2"/>
                    <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
            </div>

            <div class="field col-12 md:col-3">
                <label for="coeficiente" class="font-bold required">Possui algum tipo de deficiência?</label>
                <ValidationProvider name="deficiencia" rules="required" v-slot="{ errors }" mode="lazy">
                    <Dropdown id="deficiencia"  v-model="inscricao.concorreVagasReservadas" @change="changePossuiDeficiencia()"  :options="dropdownValues" :class="{ 'field-invalid': errors[0]  }"/>
                    <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
            </div>

            <div class="field col-12 md:col-3">
                <label for="coeficiente" class="font-bold required">Precisa de atendimento especial?</label>
                <ValidationProvider name="atendimentoEspecial" rules="" v-slot="{ errors }" mode="lazy">
                    <Dropdown id="atendimentoEspecial" v-model="inscricao.atendimento_especial" :options="dropdownValues" :class="{ 'field-invalid': errors[0]  }"/>
                    <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
            </div>

            <div  v-if="selectedFileLaudo"   class="field col-12 md:col-4" >
                <label for="file_laudo" class="font-bold mr-4">Laudo médico</label>
                <i class="pi pi-check" style="color: green;"></i>
            </div>
            <div  v-if="selectedFileLaudo"   class="field col-12 md:col-6" >
                <label for="file_laudo" class="font-bold mr-4">{{ selectedFileLaudo.name }}</label>
                <button @click="changePossuiDeficiencia()">Escolher outro arquivo</button>
            </div>

            <div class="field col-12 md:col-8" v-if="processo.tipoSelecao.estagio">
                <label for="coeficiente" class="font-bold required">Instituição de Ensino Atual</label>
                <ValidationProvider name="Instituição de Ensino Atual" rules="required" v-slot="{ errors }" mode="lazy">
                    <Dropdown id="instituicaoEnsino" v-model="inscricao.instituicaoEnsino" :options="listaInstiuicao"  optionLabel="descricao" :class="{ 'field-invalid': errors[0]  }" />
                    <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
            </div>

            <div class="field col-12 md:col-4" v-if="processo.tipoSelecao.estagio">
                <label for="coeficiente" class="font-bold required">Quantidade de Horas Cursadas</label>
                <ValidationProvider name="Quantidade de Horas Cursadas" rules="required" v-slot="{ errors }" mode="lazy">
                    <InputNumber id="horasCursadas" v-model="inscricao.horasCursadas"
                                mode="decimal" locale="pt-BR"
                                :minFractionDigits="0" :maxFractionDigits="0"/>
                    <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                </ValidationProvider>
            </div>

            <div class="field col-12 md:col-12" v-if="inscricao.atendimento_especial==='Sim'">
                 <ValidationProvider name="Descreva sua necessidade para a prova" rules="required" v-slot="{ errors }" mode="lazy">
                    <label for="desc_atend_especial" class="font-bold required">Descreva sua necessidade para a prova</label>
                    <Textarea v-model="inscricao.desc_atend_especial" :autoResize="true" rows="5" cols="100" />
                    <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                 </ValidationProvider>
            </div>

            <div class="flex field col-12 md:col-4 align-items-center">
                <label for="identidade" class="font-bold required ">
                    Documento de identificação pessoal (Carteira de Identidade, Carteira Nacional de Habilitação, Carteira de Trabalho, Carteira Profissional ou Passaporte) [*.pdf]
                </label>
            </div>
            <div class="flex field col-12 md:col-6 align-items-center">
                <input  id="file_identidade" icon="pi pi-upload"
                        type="file" @change="onFileIdentidadeSelected"
                        required=true ref="fileInput"
                        accept="application/pdf"/>
            </div>

            <div class="flex field col-12 md:col-4 align-items-center" v-if="processo.tipoSelecao.residencia">
                <label for="comprovante_pagamento" class="font-bold required ">Comprovante de pagamento [*.pdf]</label>
            </div>
            <div class="flex field col-12 md:col-5 align-items-center" v-if="processo.tipoSelecao.residencia">
                <input  id="fileComprovantePagamento" icon="pi pi-upload" v-if="!inscricao.isentoPagamento"
                        type="file" @change="onFileComprovantePagamentoSelected"
                        required=true ref="fileInput"
                        accept="application/pdf"/>
            </div>
            <div class="field col-12 md:col-3 field-checkbox" v-if="processo.tipoSelecao.residencia">
                <Checkbox v-model="inscricao.isentoPagamento" id="isentoPagamento" :binary="true" />
                <label class="font-bold" for="isentoPagamento">
                    Fui declarado isento de pagamento pelo Tribunal de Contas do Estado
                    <small style="display: block; color: #dc2626; margin-top: 0.35rem;">(certifique-se da confirma&ccedil;&atilde;o da sua isen&ccedil;&atilde;o pelo TCE/AM antes de marcar essa op&ccedil;&atilde;o)</small>
                </label>
            </div>

            <div class="field col-12 md:col-4" v-if="processo.tipoSelecao.estagio">
                <label for="identidade" class="font-bold required">Declaração da faculdade [*.pdf] </label>
            </div>
            <div class="field col-12 md:col-6" v-if="processo.tipoSelecao.estagio">
                <input  id="file_matricula" icon="pi pi-upload"
                        type="file" @change="onFileComprovanteMatriculaSelected"
                        required=true ref="fileInput"
                        accept="application/pdf"/>
            </div>

           <div class="field col-12 md:col-4" v-if="processo.tipoSelecao.estagio">
                <label for="historico" class="font-bold required  ">Histórico escolar com coeficiente de rendimento [*.pdf] </label>
            </div>
            <div class="field col-12 md:col-6" v-if="processo.tipoSelecao.estagio">
               <input   id="file_historico" icon="pi pi-upload"
                        type="file" @change="onFileSelected"
                        required=true ref="fileInput"
                        accept="application/pdf"/>
            </div>
            <div class="field col-12 md:col-8 field-checkbox">
                <Checkbox v-model="lgpd" id="lgpd" :binary="true" />
                <label class="font-bold required col-12">Ao submeter a minha inscrição, eu, o(a) Titular de Dados,
                    autorizo e declaro que estou ciente que o Tribunal de Contas do Estado do Amazonas – TCE-AM (“Controlador”) tratará dados pessoais de minha titularidade
                    para fins de seleção de pessoas para o seu programa de estágio/residência, nos termos dos artigos 7º, I, e 11, I
                    da Lei nº 13.709/2018 (Lei Geral de Proteção de Dados Pessoais – LGPD).</label>
            </div>
        </div>

            <div class="field col-12 md:col-12">
                <div class="field col-12 md:col-12">
                    <Button label="Inscrever-se" icon="pi pi-check" iconPos="left" type="submit" class="m-2" style="width: 150px" :disabled="!lgpd"></Button>
                    <router-link to="/">
                        <Button label="Cancelar" icon="pi pi-arrow-circle-left" iconPos="left" class="p-button-secondary m-2" style="width:150px"></Button>
                    </router-link>
		        </div>
            </div>
            <Loading/>

            <Dialog header="Inscrição recebida" :visible.sync="display" :style="{width: '30vw'}" :modal="true" :closable="false">
                <p class="text-justify">
                    Sua inscrição foi recebida com sucesso. Após a etapa das inscrições,
                    iniciar-se-á a etapa de análise das inscrições e documentações.
                </p>
                <br />
                <p class="text-justify">
                    Não será admitida a inscrição do candidato que não enviar os documentos exigidos no edital ou não atender os demais requisitos previstos.
                </p>
                <br />
                <p class="text-justify">
                    Atendendo os requisitos previstos no edital, o candidato será habilitado a participar do processo seletivo.
                </p>
                <br />
                <p class="text-justify">
                    Fique atento e acompanhe sua inscrição por aqui!
                </p>
                <template #footer>
                    <Button label="OK" @click="close" icon="pi pi-check" class="p-button-secondary"/>
                </template>
            </Dialog>

            <Dialog id="dialogLaudo" header="Autodeclaração de Pessoa com Deficiência (PcD)" :visible.sync="displayAlertaLaudo" :modal="true" :closable="false">

                <TextoLaudoMedico />
                <br/>
                <div class="field col-12 md:col-12">
                    <label for="file_laudo" class="font-bold required">Autodeclaração de Pessoa com Deficiência (PcD) - Anexo I do Edital [*.pdf] </label>
                    <input id="file_laudo" type="file" @change="onFileLaudoSelected"
                                :required="true" name="file_laudo" ref="fileLaudoInput" accept="application/pdf"/>
                </div>

                <template #footer>
                    <Button label="OK" @click="closeAlertaLaudo" icon="pi pi-check" class="p-button-secondary"/>
                </template>

            </Dialog>

        </form>
        </ValidationObserver>

    </Panel>

</template>

<script>
import { validacaoFormulario } from '@/validacaoFormulario'
import http from '@/http';
import { tratamentoDeErros } from '@/tratamentoDeErros';
import TextoLaudoMedico from '../components/TextoLaudoMedico.vue'
import Loading from '../components/Loading.vue';
import InscricaoService from '../service/InscricaoService';

export default {

    components: {TextoLaudoMedico,'Loading': Loading,},

    mixins: [tratamentoDeErros, validacaoFormulario],

    data() {
        return {
            messages: [],
            display: false,
            lgpd: false,
            coeficienteEscolar: 0,
            selectedFile: null,
            selectedFileLaudo: null,
            rules: '',
            displayAlertaLaudo: false,
            processo: {
                	nome: '',
					datHoraInicioInscricao: '',
					datHoraFimInscricao: '',
					coeficienteMinimo: null,
					areas: [],
                    tipoSelecao: { estagio: false}
			},
            inscricao: {
                selecaoEstagioId: null,
                areaId: null,
                coefic_red_escolar: null,
                comprovante_deficiencia: null,
                comprovante_red_escolar: null,
                comprovante_rg: null,
                comprovante_mat: null,
                atendimento_especial: false,
                concorreVagasReservadas: false,
                isentoPagamento: false,
                desc_atend_especial: '',
                mensagem: 'Inscrição foi recebida e está aguardando a análise dos dados e documentação informados'
            },
			dropdownAreas: [],
			dropdownValues: ['Não','Sim'],
            selecteddropdownValues: 'Não',
            listaInstiuicao: [],
            inscricaoService: null,
        };
    },

		processoService:null,

    mounted(){
        let processoData = {...this.$route.params.processo};

        this.processo.nome =  processoData.nome;
        this.processo.coeficienteMinimo = processoData.coeficienteMinimo;
        this.processo.tipoSelecao = processoData.tipoSelecao;
        this.dropdownAreas = processoData.selecaoEstagioArea
        this.inscricao.selecaoEstagioId = processoData.id
        this.inscricao.atendimento_especial = 'Não';
        this.rules=`required|min_value: ${this.processo.coeficienteMinimo}|max_value:10`;

        this.inscricaoService = new InscricaoService();
        this.inscricaoService.getListaIntituicoes()
                    .then((resposta) => {
                        this.listaInstiuicao = resposta;
                    });
   },
    methods: {
        changePossuiDeficiencia(){
            if(this.inscricao.concorreVagasReservadas!='Sim'){
                this.inscricao.atendimento_especial = null;
                this.inscricao.desc_atend_especial = null;
                this.selectedFileLaudo = null;
            }else{
                this.displayAlertaLaudo = true;
            }
        },

        closeAlertaLaudo(){
            this.displayAlertaLaudo = false;
            console.log('selectedFileLaudo: ', this.selectedFileLaudo);
            if(this.selectedFileLaudo==null){
                this.inscricao.concorreVagasReservadas ='Não';
            }

        },

        cadastrar(){
            console.clear();
		    console.log('efetuando inscricao ...');
            this.$store.state.dlgLoading = true;
            const fd = new FormData();
            fd.append('selecaoEstagioId', this.inscricao.selecaoEstagioId);
            fd.append('areaId', this.inscricao.areaId);

            console.log('areaId: ', this.inscricao.areaId);

            fd.append('coefic_red_escolar', this.inscricao.coefic_red_escolar ? this.inscricao.coefic_red_escolar : 0);

            fd.append('concorre_vagas_reservadas', this.inscricao.concorreVagasReservadas=='Sim');

            if(this.inscricao.concorreVagasReservadas==='Sim'){
                fd.append('comprovante_deficiencia', this.selectedFileLaudo);
            }

            if(!this.processo.tipoSelecao.estagio){
                this.inscricao.isentoPagamento = (this.inscricao.isentoPagamento == undefined ? false : this.inscricao.isentoPagamento);
                fd.append('isentoPagamento', this.inscricao.isentoPagamento);
                if (!this.inscricao.isentoPagamento) {
                    // comprovante de pagamento
                    fd.append('docComprovantePagamento', this.selectedFileComprovantePagamento);
                }
            }

            fd.append('atendimento_especial', this.inscricao.atendimento_especial=='Sim');
            fd.append('desc_atend_especial', this.inscricao.desc_atend_especial);

            fd.append('mensagem', this.inscricao.mensagem);
            fd.append('comprovante_rg', this.selectedFileIdentidade);


            if (this.processo.tipoSelecao.estagio) {
                fd.append('comprovante_red_escolar', this.selectedFile);
                fd.append('comprovante_mat', this.selectedFileComprovante_mat);
                fd.append('idInstituicao', this.inscricao.instituicaoEnsino.id);
                fd.append('horasCursadas', this.inscricao.horasCursadas);
            }

            http.post('inscricao', fd).then(() => {
                    // console.log('resposta: ', JSON.stringify(resposta, null, 3))
                    this.$store.state.dlgLoading = false;
                    this.open();
				})
		   .catch(erro =>  {
				console.error(erro);
				this.messages = this.getMessagesError(erro);
                this.$store.state.dlgLoading = false;
			})
		},

		onUpload() {
			this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
		},

        onFileSelected(event){
            console.log('onFileSelected...')

            this.messages = [];

            this.selectedFile = event.target.files[0]

            var fileUpload = document.getElementById("file_historico");

            console.log('fileUpload.value ...', fileUpload);

            if(!fileUpload.value.endsWith('.pdf')) {
                this.selectedFile = null;
                fileUpload.value='';
                this.messages = [{severity: 'error', content: 'Somente arquivos do tipo *.pdf são permitidos'}];
            }

        },

        onFileLaudoSelected(event){
            console.log('onFileLaudoSelected...')

            this.messages = [];

            this.selectedFileLaudo = event.target.files[0]

            var fileUpload = document.getElementById("file_laudo");

            // console.log('event.target.files[0]  ...', JSON.stringify(event.target.files[0], null, 3));

            if(!fileUpload.value.endsWith('.pdf')) {
                this.selectedFileLaudo = null;
                fileUpload.value='';
                this.messages = [{severity: 'error', content: 'Somente arquivos do tipo *.pdf são permitidos'}];
            }

        },
        onFileIdentidadeSelected(event){
            console.log('onFileIdentidadeSelected...')

            this.messages = [];
            this.selectedFileIdentidade = event.target.files[0]
            var fileUpload = document.getElementById("file_identidade");

            console.log('fileUpload.value ...', fileUpload.value);

            if(!fileUpload.value.endsWith('.pdf')) {
                this.selectedFileIdentidade = null;
                fileUpload.value='';
                this.messages = [{severity: 'error', content: 'Somente arquivos do tipo *.pdf são permitidos'}];
            }
        },
        onFileComprovantePagamentoSelected(event){
            this.messages = [];
            this.selectedFileComprovantePagamento = event.target.files[0]
            var fileUpload = document.getElementById("fileComprovantePagamento");

            console.log('fileUpload.value ...', fileUpload.value);

            if(!fileUpload.value.endsWith('.pdf')) {
                this.selectedFileComprovantePagamento = null;
                fileUpload.value='';
                this.messages = [{severity: 'error', content: 'Somente arquivos do tipo *.pdf são permitidos'}];
            }
        },
        onFileComprovanteMatriculaSelected(event){
            console.log('onFileComprovanteMatriculaSelected...')

            this.messages = [];

            this.selectedFileComprovante_mat = event.target.files[0]

            var fileUpload = document.getElementById("file_matricula");

            console.log('fileUpload.value ...', fileUpload.value);

            if(!fileUpload.value.endsWith('.pdf')) {
                this.selectedFileComprovante_mat = null;
                fileUpload.value='';
                this.messages = [{severity: 'error', content: 'Somente arquivos do tipo *.pdf são permitidos'}];
            }

        },

        open() {

            this.display = true;
        },
        close() {
            this.display = false;
            this.$router.push( { name: 'minha.inscricao' })
        }

	}
}
</script>

<style>

    .p-dialog {
        width: 30vw !important;
    }

@media screen and (max-width: 800px) {

    .p-dialog {
        width: 90vw !important;
    }
}

</style>
